import { Box, Typography, styled } from '@mui/material';

export const StubContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100vw',
  height: '100vh',
}));

export const DescriptionContainer = styled(Typography)(({ theme }) => ({
  marginBottom: '16px',
  maxWidth: '418px',
  color: theme.palette.case.neutral.n800,

  [theme.breakpoints.down('sm')]: {
    maxWidth: '279px',
  },
}));
